/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ReadEMARequestBody,
  ReadEMARequestBody$Outbound,
  ReadEMARequestBody$outboundSchema,
} from "../components/reademarequestbody.js";

export type ReadEMASecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ReadEMASecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ReadEMASecurity = {
  option1?: ReadEMASecurityOption1 | undefined;
  option2?: ReadEMASecurityOption2 | undefined;
};

export type ReadEMARequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  readEMARequestBody: ReadEMARequestBody;
};

/** @internal */
export type ReadEMASecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ReadEMASecurityOption1$outboundSchema: z.ZodMiniType<
  ReadEMASecurityOption1$Outbound,
  ReadEMASecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function readEMASecurityOption1ToJSON(
  readEMASecurityOption1: ReadEMASecurityOption1,
): string {
  return JSON.stringify(
    ReadEMASecurityOption1$outboundSchema.parse(readEMASecurityOption1),
  );
}

/** @internal */
export type ReadEMASecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ReadEMASecurityOption2$outboundSchema: z.ZodMiniType<
  ReadEMASecurityOption2$Outbound,
  ReadEMASecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function readEMASecurityOption2ToJSON(
  readEMASecurityOption2: ReadEMASecurityOption2,
): string {
  return JSON.stringify(
    ReadEMASecurityOption2$outboundSchema.parse(readEMASecurityOption2),
  );
}

/** @internal */
export type ReadEMASecurity$Outbound = {
  Option1?: ReadEMASecurityOption1$Outbound | undefined;
  Option2?: ReadEMASecurityOption2$Outbound | undefined;
};

/** @internal */
export const ReadEMASecurity$outboundSchema: z.ZodMiniType<
  ReadEMASecurity$Outbound,
  ReadEMASecurity
> = z.pipe(
  z.object({
    option1: z.optional(z.lazy(() => ReadEMASecurityOption1$outboundSchema)),
    option2: z.optional(z.lazy(() => ReadEMASecurityOption2$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function readEMASecurityToJSON(
  readEMASecurity: ReadEMASecurity,
): string {
  return JSON.stringify(ReadEMASecurity$outboundSchema.parse(readEMASecurity));
}

/** @internal */
export type ReadEMARequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  ReadEMARequestBody: ReadEMARequestBody$Outbound;
};

/** @internal */
export const ReadEMARequest$outboundSchema: z.ZodMiniType<
  ReadEMARequest$Outbound,
  ReadEMARequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    readEMARequestBody: ReadEMARequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      readEMARequestBody: "ReadEMARequestBody",
    });
  }),
);

export function readEMARequestToJSON(readEMARequest: ReadEMARequest): string {
  return JSON.stringify(ReadEMARequest$outboundSchema.parse(readEMARequest));
}
